//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ZSelect from "@/components/Select"
import { _q } from "@/util/util"
import { go } from "./../../util/router"
import {
  putInQuireBatchList,
  getGoldstone,
  getShoppingCartQty,
  putAddBatchCart,
  putDeleteCart,
  getCommodityDetail
} from "./../../service/index"
let Items = [
  { oid: "1234", name: "全部" },
  { oid: "2345", name: "1" }
]
const ZJD = require("./../../config/ZJD.json")
const ZColor = require("./../../config/ZColor.json")
export default {
  name: "list",
  data () {
    return {
      Items9: { id: 1, children: Items },
      pData: {
        SortType: 0,
        CommodityOid: "",
        ZJSBM: "",
        PriceFrom: "",
        PriceTo: "",
        ZZSZLFrom: "",
        ZZSZLTo: "",
        ZJDFrom: "",
        ZJDTo: "",
        ZZJQHFrom: "",
        ZZJQHTo: "",
        ZXLCCFrom: "",
        ZXLCCTo: "",
        ZSDFrom: "",
        pageNum: 0,
        pageSize: 10,
        pageCount: 0
      },
      List: [],
      List2: [],
      isAll: false,
      isSortPrice: false,
      isSortName: false,
      isSelect: false,
      isLock: false,
      KeyWord: "",
      JSValue: "",
      CartData: {},
      ZJD: ZJD,
      ZColor: ZColor,
      checkQty: 0,
      isPair: false,
      Oid: null,
      pairOid: null,
      LABOR: null,
      topFlag: false,
      canOut: false,
      Detail: { Price: 0 }
    }
  },
  components: {
    ZSelect: ZSelect
  },
  created () {
    this.pData.CommodityOid = this.$route.params.id

    this.GetDetail()
    this.getShopCartQty()
  },
  mounted () {
    this.pagescroll()
    window.addEventListener("scroll", this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener("scroll", this.scrollToTop)
  },
  watch: {
    list: function (to, from) { }
  },
  methods: {
    GetDetail () {
      getCommodityDetail(
        {
          commodityOid: this.$route.params.id,
          bannerOId: this.$route.query.bannerOId //专区id
        },
        result => {
          if (result.code === "1") {
            this.Detail = JSON.parse(result.data)

            if (this.Detail && this.Detail.ZPM === "03") {
              this.Oid = this.$route.params.id
              this.isPair = true
              this.pairOid = this.Detail.PairOid
              this.LABOR = this.Detail.Sex
            }
            if (this.Detail) {
              if (!this.Detail.ZYDDH) {
                this.canOut = false
              } else {
                this.canOut = true
              }
            }

            this.searchData()
          }
        }
      )
    },
    onResultChange (val) {
      console.log(val)
      if (val.target === "JD") {
        this.pData.ZJDFrom = val.idx
      } else if (val.target === "ZC") {
        this.pData.ZSDFrom = val.idx
      }
    },
    doSelect () {
      this.isSelect = false
    },
    checkIpt (e) {
      let self = e.target
      let re = /^[0-9]+.?[0-9]*$/
      if (!re.test(self.value)) {
        self.value = ""
      }
    },
    showHide () {
      if (_q(".header").className.indexOf("spec_open") > -1) {
        _q(".header").removeClass("spec_open")
        _q(".header").parentNode.style.height = "71px"
      } else {
        _q(".header").addClass("spec_open")
        _q(".header").parentNode.style.height = "180px"
      }
    },
    doCheckAll () {
      if (this.isAll) {
        this.isAll = false
        for (let item of this.List) {
          item.cur = false
        }
        //          let list = this.List.filter(c => c.cur === true)
        //          let BatchDetails = list.map((item, index) => ({
        //            ZMATNR: item.ZMATNR
        //          }))
        //          this.putDeleteCart(BatchDetails)
      } else {
        this.isAll = true
        for (let item of this.List) {
          item.cur = true
        }
        //          this.putAddBatchCart()
      }
      this.checkQty = this.List.filter(c => c.cur === true).length
    },
    check (item) {
      if (item.cur) {
        item.cur = false
        this.isAll = false
        //          let BatchDetails = [{
        //            ZMATNR: item.ZMATNR
        //          }]
        //          this.putDeleteCart(BatchDetails)
      } else {
        item.cur = true
        this.isAll = !this.List.filter(c => c.cur === false).length > 0
        //          this.putAddBatchCart()
      }
      this.checkQty = this.List.filter(c => c.cur === true).length
    },
    sortByPrice () {
      this.List.sort((a, b) => {
        return a.ZJSJE - b.ZJSJE
      })
      if (this.isSortPrice) {
        this.isSortPrice = false
      } else {
        this.isSortPrice = true
        this.List.reverse()
      }
    },
    sortByName () {
      this.List.sort((a, b) => {
        return a.ZZSZL - b.ZZSZL
      })
      if (this.isSortName) {
        this.isSortName = false
      } else {
        this.isSortName = true
        this.List.reverse()
      }
    },
    searchData () {
      let vm = this
      let postData = vm.pData
      if (Number(postData.PriceFrom) > Number(postData.PriceTo)) {
        vm.showToast("价格至不能低于价格从!")
        return
      }
      if (Number(postData.ZZSZLFrom) > Number(postData.ZZSZLTo)) {
        vm.showToast("主石至不能低于主石从!")
        return
      }
      if (Number(postData.ZZJQHFrom) > Number(postData.ZZJQHTo)) {
        vm.showToast("戒指圈号至不能低于戒指圈号从!")
        return
      }
      if (Number(postData.ZXLCCFrom) > Number(postData.ZXLCCTo)) {
        vm.showToast("项链尺寸至不能低于项链尺寸从!")
        return
      }
      if (Number(postData.ZJDFrom) > Number(postData.ZJDTo)) {
        vm.showToast("净度至不能低于净度从!")
        return
      }
      postData.pageCount = 0
      postData.pageNum = 0
      vm.List = []
      console.log(JSON.stringify(postData))
      vm.putInQuireBatchList()
    },
    putInQuireBatchList () {
      let vm = this
      vm.pData.bannerOId = vm.$route.query.bannerOId //专区id
      vm.isLock = true
      putInQuireBatchList(vm.pData, result => {
        vm.isLock = false
        if (result.code === "1") {
          let tag = JSON.parse(result.tag)
          vm.pData.pageCount = Number(tag.Dict.records)
          let List = JSON.parse(result.data)
          console.log(List)
          for (let item of List) {
            item.cur = false
            vm.List.push(item)
          }
        }
      })
    },
    searchData2 () {
      let vm = this
      vm.isSelect = true
      vm.List2 = []
      getGoldstone(vm.$route.params.id, result => {
        if (result.code === "1") {
          vm.List2 = JSON.parse(result.data)
        }
      })
    },
    sltJS (obj) {
      this.JSValue = obj.ZJSMC
      this.pData.ZJSBM = obj.ZJSBM
      this.isSelect = false
    },
    getShopCartQty () {
      let vm = this
      getShoppingCartQty(result => {
        if (result.code === "1") {
          vm.CartData = JSON.parse(result.data)
        }
      })
    },
    putAddBatchCart () {
      let vm = this
      let list = vm.List.filter(c => c.cur === true)
      let BatchDetails = list.map((item, index) => ({
        ZMATNR: item.ZMATNR
      }))
      if (BatchDetails.length === 0) {
        return
      }
      let pData = {
        CommodityOid: vm.pData.CommodityOid,
        BatchDetails: BatchDetails
      }
      putAddBatchCart(pData, result => {
        if (result.code === "1") {
          let data = JSON.parse(result.data)
          if (data.IsSuccess) {
            // this.showAlert('提交成功！')
            // this.showAlert(
            //   '<span style="color:#B71219;">提交成功，请尽快结算，以便分配库存！</span>'
            // );
            this.showConfirm(
              '<span style="color:#B71219;">加入成功</span>',
              undefined,
              () => {
                this.doDetail()
              },
              "继续下单",
              "去购物车"
            )
            vm.CartData = data.CartTotal
          }
        }
      })
    },
    putDeleteCart (BatchDetails) {
      let vm = this
      let pData = {
        CommodityOid: vm.pData.CommodityOid,
        BatchDetails: BatchDetails
      }
      putDeleteCart(pData, result => {
        if (result.code === "1") {
          let data = JSON.parse(result.data)
          if (data.IsSuccess) {
            vm.CartData = data.CartTotal
          }
        }
      })
    },
    pagescroll () {
      let self = this
      window.onscroll = function () {
        let body = document.body
        let scrollTop =
          body.scrollTop === 0
            ? document.documentElement.scrollTop
            : body.scrollTop
        let dHeight = body.scrollHeight
        let height = document.documentElement.clientHeight
        //          console.log(scrollTop + '|' + dHeight + '｜' + height)
        if (scrollTop + height >= dHeight - 100) {
          if (self.isSelect) {
            if (
              self.pData.pageCount - self.pData.pageNum * self.pData.pageSize >
              self.pData.pageSize
            ) {
              if (!self.isLock) {
                self.isLock = true
                self.pData.pageNum += 1
                self.putInQuireBatchList()
              }
            }
          } else {
            if (
              self.pData.pageCount - self.pData.pageNum * self.pData.pageSize >
              self.pData.pageSize
            ) {
              if (!self.isLock) {
                self.isLock = true
                self.pData.pageNum += 1
                self.putInQuireBatchList()
              }
            }
          }
        }
      }
    },
    doDetail (idx) {
      switch (idx) {
        case 1:
          if (!this.canOut) {
            this.showAlert(
              `<p class="red">抱歉，该商品不支持下单，请前往常规配货专区下单。将会有线下工作人员帮您配货。<p>`
            )
            return
          }
          // 直接委外
          go("/outbatchdetail/Z009/" + this.$route.params.id, this.$router)
          return
        case 0:
          //go("/home1", this.$router);
          this.$router.go(-2)
          return
      }

      go("/shopcart", this.$router)
    },
    goTop () {
      const that = this
      let timer = setInterval(() => {
        let speed = Math.floor(-that.scrollTop / 6)
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + speed
        if (that.scrollTop == 0) {
          clearInterval(timer)
        }
      }, 10)
    },
    scrollToTop () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.scrollTop = scrollTop
      if (this.scrollTop > 60) {
        this.topFlag = true
      } else {
        this.topFlag = false
      }
    },
    getGJTag (val) {
      if (/^IIDGR/.test(val)) {
        return "百面"
      }
      if (/^HRD/.test(val)) {
        return "HRD"
      }
      if (/^GIA/.test(val)) {
        return "GIA"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/product/list.vue